<template>
  <div class="pay-manage-page">
    <top-bar :topbarList="payManageTopBarList"></top-bar>
    <router-view></router-view>
  </div>
</template>

<script>
import topBar from "@/components/topBar.vue";
import { payManageIndexMixins } from "@/mixins/payManageIndexMixins";

export default {
  mixins: [payManageIndexMixins],
  data() {
    return {};
  },
  computed: {},
  components: {
    topBar,
  },
};
</script>

<style lang="less" scoped>
.pay-manage-page {
  height: 100%;
}
</style>
